import {
  Badge,
  Box,
  Button,
  Flex,
  Heading,
  Image,
  Text,
} from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { MdPlayCircle } from "react-icons/md";

const VideoCard = ({ video }) => {
  return (
    <Box
      borderRadius="1.25rem"
      overflow="hidden"
      bg="white"
      boxShadow="0 2px 12px rgba(0,0,0,0.08)"
      border="1px solid"
      borderColor="gray.100"
      _hover={{ boxShadow: "0 8px 32px rgba(0,0,0,0.14)", transform: "translateY(-4px)" }}
      transition="all 0.25s"
      display="flex"
      flexDir="column"
    >
      <Link to={`./${video.videoId}`}>
        <Box position="relative" overflow="hidden">
          <Image
            src={`${process.env.REACT_APP_S3_BASEURL}/videos_images/${video.image}`}
            w="100%"
            h="180px"
            objectFit="cover"
            _hover={{ transform: "scale(1.04)" }}
            transition="transform 0.3s"
          />
          <Flex
            position="absolute"
            inset={0}
            alignItems="center"
            justifyContent="center"
            bg="rgba(0,0,0,0.18)"
            opacity={0}
            _hover={{ opacity: 1 }}
            transition="opacity 0.2s"
          >
            <Box as={MdPlayCircle} color="white" fontSize="4rem" />
          </Flex>
        </Box>
      </Link>

      <Flex flexDir="column" flex={1} p={4} gap={2}>
        <Heading size="sm" noOfLines={2} color="gray.800">
          {video.name}
        </Heading>
        <Text fontSize="0.85rem" color="gray.500" fontStyle="italic" noOfLines={1}>
          {video.authorName} — {video.eventName}
        </Text>
        <Flex gap={1} wrap="wrap" mt={1}>
          {video?.tags?.[0] &&
            video.tags.map((tag) => (
              <Badge colorScheme="green" fontSize="0.7rem" key={tag}>
                {tag}
              </Badge>
            ))}
        </Flex>
        <Flex justifyContent="space-between" alignItems="center" mt="auto" pt={3}>
          <Text fontSize="0.8rem" color="gray.400">
            {video.youtubeViews} visualizações
          </Text>
          <Link to={`./${video.videoId}`}>
            <Button size="sm" colorScheme="green">
              Assistir
            </Button>
          </Link>
        </Flex>
      </Flex>
    </Box>
  );
};

export default VideoCard;
